'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CountDownTimer = require('./CountDownTimer');

var _CountDownTimer2 = _interopRequireDefault(_CountDownTimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CountDownTimer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CountDownTimer/index.js
// module id = 569
// module chunks = 11